<template>
    <div class="mobile-index" style="background-color: #1b55bb;position: fixed;top:0;right: 0;bottom: 0;left: 0">
        <el-container style="height: 100%;">
            <el-header>
                <h3 style="color: #FFF"> 河北省计量资源共享服务平台 </h3>
                <div style="margin-top: 40px;">
                    <el-tabs v-model="mode" :stretch="true" @tab-click="clickTab">
                        <el-tab-pane :name="m.key" :label="m.text" :key="m.key" v-for="m in modeList"></el-tab-pane>
                    </el-tabs>
                </div>
            </el-header>
            <el-main class="main" style="margin-top: 100px;">
                <template v-if="mode === 'INSTR_NAME_QUERY'">
                    <el-autocomplete
                            @change="changeContent"
                            :clearable="true"
                            @clear="content = ''"
                            style="width: 100%"
                            class="input-with-select"
                            v-model="content"
                            :fetch-suggestions="querySearch"
                            placement="bottom"
                            placeholder="请输入器具名称"
                            :trigger-on-focus="false"
                            value-key="name"
                    >
                        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
                    </el-autocomplete>
                </template>
                <template v-else>
                    <el-input :clearable="true" @clear="content = ''" placeholder="请输入单位名称" v-model="content" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
                    </el-input>
                </template>
                <template v-if="mode==='INSTR_NAME_QUERY'">
                    <el-breadcrumb separator-class="el-icon-arrow-right" v-if="region.codeList.length > 0" style="margin-top:10px; font-size: 15px;font-weight: 700;">
                        <el-breadcrumb-item @click.native="skip(-1)"> 河北省 </el-breadcrumb-item>
                        <el-breadcrumb-item v-for="(code,codeIndex) in region.codeList" :key="'breadcrumb_' + code.code" @click.native="skip((codeIndex))"> {{code.label}}</el-breadcrumb-item>
                    </el-breadcrumb>
                </template>
                <div style="height: calc(100% - 40px);overflow: auto;">
                    <template v-if="mode === 'OWNER_NAME_QUERY' || (mode==='INSTR_NAME_QUERY' && step === 2)">
                        <el-card class="main-card" :body-style="{padding:'10px'}" style="margin-top:10px; font-size: 15px;font-weight: 700;" shadow="never" v-for="data in dataList" :key="data.id" @click.native="toDetail(data.id)">
                            {{data.name}} <i style="float: right" class="el-icon-arrow-right"></i>
                        </el-card>
                    </template>
                    <template v-else>
                        <el-card class="main-card" :body-style="{padding:'10px'}" style="margin-top:10px; font-size: 15px;font-weight: 700;" shadow="never" v-for="region in region.list" :key="region.sid" @click.native="changeCode(region)">
                            {{region.name}}<span style="color: #D65;">（{{region.number}}）</span><i style="float: right" class="el-icon-arrow-right"></i>
                        </el-card>
                    </template>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import {mechanismApi} from "@/api/organization";
    import {instrumentApi} from "@/api/instrument";
    import {dictApi} from "../../api/organization";
    export default {
        name: "mobile-index",
        data() {
            return {
                step: 0, //0市 1区 2单位列表
                region: {
                    list: [],
                    sid: '',
                    code: '',
                    codeList: [],
                },
                projectList:[],
                content: '',
                mode: 'OWNER_NAME_QUERY', //
                modeList: [{key: 'OWNER_NAME_QUERY', text: '按单位名称搜索'}, {key: 'INSTR_NAME_QUERY', text: '按器具名称搜索'}],
                dataList: [],
            }
        },
        created() {
            this.listDictInstrument();
        },
        methods: {
            changeContent(value){
                console.log("changeContent---: " + value);
            },
            querySearch(queryString, cb) {
                const projectList = this.projectList;
                const results = queryString ? projectList.filter(this.createFilter(queryString)) : [];
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (projectList) => {
                    return (projectList.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },
            listDictInstrument() {
                dictApi.listDictInstrument().then(r => {
                    if (r.data.result === 0) {
                        const rData = r.data.data;
                        let projectList = [];
                        this.porjectTree(rData, projectList);
                        console.log(projectList);
                        this.projectList = projectList;
                    }
                })
            },
            porjectTree(list, projectList){
                list.forEach((project) => {
                    if(project.children.length > 0){
                        this.porjectTree(project.children, projectList);
                    }else{
                        projectList.push(project);
                    }
                })
            },
            clickTab(){
                this.content = '';
                this.dataList = [];
                this.step = 0; //0市 1区 2单位列表
                this.region = {
                    list: [],
                    sid: '',
                    code: '',
                    codeList: [],
                }
            },
            changeCode(data){
                this.region.sid = data.sid;
                this.region.code = data.code;
                this.region.codeList.push({sid: data.sid, code: data.code, label: data.name});
                this.step++;
                this.search();
            },
            search(){
                if(this.mode === 'OWNER_NAME_QUERY'){
                    if(this.content === ''){
                        this.$message.warning("请输入单位名称");
                        return;
                    }
                    this.loadMechanism();
                }else{

                    if(this.content === ''){
                        this.$message.warning("请输入器具名称");
                        return;
                    }
                    if(this.step === 2){
                        this.loadMechanism();
                    }else{
                        this.loadInstrumentRegionNum();
                    }
                }
            },
            loadMechanism(){
                this.listMechanism().then((r) => {
                    if(r.data.result === 0){
                        this.dataList = r.data.data;
                    }else{
                        this.dataList = [];
                    }
                });
            },
            loadInstrumentRegionNum(){
                if(this.content == ""){
                    return;
                }
                instrumentApi.listInstrumentRegionNum({name: this.content, sid: this.region.sid, status: 2}).then((r) =>{
                    if(r.data.result === 0){
                        this.region.list = r.data.data;
                    }else{
                        this.region.list = [];
                    }
                });
            },
            listMechanism(){
                if(this.mode === 'OWNER_NAME_QUERY'){
                    return mechanismApi.listMechanismV2({name: this.content, organizationType: ['0001', '0006'].join(",")});
                }else{
                    return instrumentApi.listInstrumentMechanism({name: this.content, code: this.region.code})
                }
            },
            toDetail(ownerId){
                this.$router.push("/mp/detail/" + ownerId);
            },
            skip(index){
                if(index === -1){
                    this.step = 0;
                    this.region.sid = "";
                    this.region.code = "";
                    this.region.codeList = [];
                    this.loadInstrumentRegionNum();
                    return;
                }
                const codeData = this.region.codeList[index];
                this.region.sid = codeData.sid;
                this.region.code = codeData.code;
                this.region.codeList.splice(index + 1,  this.region.codeList.length -1)
                this.step = index + 1;
                this.loadInstrumentRegionNum();
            },
        }
    }
</script>
<style lang="scss">
    .mobile-index {
        background-image: url(../../../static/image/indexbg.jpg);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: top center;
        font-size: 16px !important;
        .el-select .el-input {
            width: 130px;
        }
        .input-with-select .el-input-group__prepend {
            background-color: #fff;
        }
        .el-tabs__item.is-active {
            color: bisque;
        }
        .el-tabs__item:hover{
            color: bisque;
        }
        .el-tabs__item{
            color: #FFF;
        }
        .el-tabs__active-bar{
            background-color: #FFF;
        }
        .el-tabs__nav-wrap:after{
            background-color: #1b55bb;
        }

        .el-breadcrumb__item {
            .el-breadcrumb__separator{
                color: #FFF;
            }
            .el-breadcrumb__inner{
                color: #FFF;
            }
        }
        .bg-color-sub {
            width: 100%;
            height: 40px;
            left: 0;
            bottom: 0;
            position: absolute;
        }

    }
</style>
